import { Component, Input, OnInit, ViewChild, OnChanges, SimpleChanges, ChangeDetectorRef, ViewChildren, ElementRef, QueryList, AfterViewInit } from "@angular/core";
import { Subscription } from "rxjs/Subscription";
import { Output, EventEmitter } from "@angular/core";
import * as moment from "moment";
import { RestService } from "../../shared/rest.service";
import { ItineraryService } from "../../shared/itinerary.service";
import { BsModalRef, BsModalService, ModalDirective, ModalOptions } from "ngx-bootstrap/modal";
import { RangeDateItinerary } from "../interfaz/rangeDateItinerary";
import { FormGroup} from "@angular/forms";
import { Observable } from "rxjs/Observable";
import { ResultsSearchService } from "../../home/results-search.service";
import { DatePipe } from "@angular/common";
import { UserService } from "../../pages/com.usblick.common/auth/user.service";
import { ConfirmationModalComponent } from "../modals/confirmation-modal/confirmation-modal.component";
import { MatDialog } from "@angular/material/dialog";
import { SortableComponent } from "ngx-bootstrap/sortable";
import CssFilterConverter from "css-filter-converter";
import { Router } from "@angular/router";
import { CurrencyConverterPurePipe } from "../currency-converter-pure.pipe";
import { TransportsService } from "../modals/modal-transports/transports.service";
import { HotelService } from "../modals/modal-hotel/hotel.service";
import { NotificationService } from "../notifications/notification.service";


type TView = "MULTIDESTINATION" | "RESULT";

@Component({
  selector: "usb-itinerary-sidebar",
  templateUrl: "./itinerary-sidebar.component.html",
  styleUrls: ["./itinerary-sidebar.component.scss"],
  providers: [DatePipe, CurrencyConverterPurePipe],
})
export class ItinerarySidebarComponent implements OnInit, OnChanges, AfterViewInit {
  @ViewChild("modalRooms") modalRooms: ModalDirective;

  @Input() modeView: TView;
  @Input() _actualItinerary: any;
  @Input() payload: any;
  @Input() results: any;
  @Input() origin?: any;
  @Input() currencies: any;
  @Input() currencyAgency: any;
  @Input() getClientsSettingAppBooking: any;
  @ViewChildren('icon', { read: ElementRef }) icons: QueryList<ElementRef>;
  @ViewChildren('icons_two', { read: ElementRef }) icons_two: QueryList<ElementRef>;
  @Output() isLoading = new EventEmitter<boolean>();
  @Output() changeTabEmitter = new EventEmitter<any>();
  @Output() _itinerary = new EventEmitter<any>();
  @Output() productDeleteEmitter = new EventEmitter<any>();
  @Output() modifiedTransportPriceSelectedReturn = new EventEmitter<any>();
  @Output() openModalFly = new EventEmitter<any>();
  itinerary$: Observable<any[]>;

  /* REORDER */
  @ViewChild(SortableComponent) sortableComponent: SortableComponent;
  styleSidebar: any;
  loadingReording: boolean = false;
  _activeItinerary: any;
  _destinations: any[] = [];
  _arrivalDate: string;
  _payloadArray = [];
  disableButton: Boolean;
  /* /REORDER */
  itineraryTotal: any;
  itineraryItems: any;
  product: any;
  romTaken: boolean;
  activeItineraryForm: any = null;
  showProduct = false;
  subscription: Subscription;
  modalRef: BsModalRef;
config = {
  animated: true,
  keyboard: true,
  backdrop: 'static', // Esto asegura que el modal no se cierre al hacer clic fuera
  ignoreBackdropClick: true, // Ignora los clics en el fondo para evitar el cierre del modal
};
  id: any;
  buttonDisabled: Boolean = false;
  multidestination: any;
  itinerary: any;
  nuevoObjeto = [];
  nuevoObjetoAux = [];

  nuevoObjeto2 = [];
  nuevoObjetoAux2 = [];

  totalNetPriceBooking = 0;
  totalBlickoins = 0;
  private _form: FormGroup;
  isDestroyed = false;

  cities: string[] = [];
  lastItemHotelGet: any;
  lastItemHotelService: any;
  adultsValue: number = 0;
  booleanGetItinerary:boolean = false;
  qtyChildReserve: any;
  appLoading: boolean = false;
  deleteItem: boolean;

  bsModalRef?: BsModalRef;
  firstCharge: boolean = true;
  reloadItemsReadyDelete: boolean = false;
    filterColorIcon: any;
    bodyStyle: any;
    loadingToast: any;
    expandedItems: Set<number> = new Set();
    expandedItemsBlickoins: Set<number> = new Set();

  constructor(
    private modalService: BsModalService,
    private itineraryService: ItineraryService,
    private datePipe: DatePipe,
    private resultSearchService: ResultsSearchService,
    private _rest: RestService,
    public userService: UserService,
    public dialog: MatDialog,
    private notificationService: NotificationService,
    private router: Router,
    private currencyPipe: CurrencyConverterPurePipe,
    private transporsService: TransportsService,
    private hotelService: HotelService
  ) {
    this.itineraryService.valueUltimateDate$.subscribe((res: any) => {
      this.lastItemHotelGet = res;
    });
    this.itineraryService.booleanModalActive$.subscribe((res:any) =>{
      this.booleanGetItinerary = res;
    })

  }
  ngAfterViewInit(): void {
     this.applyImageFilter();
  }

  ngOnInit() {
    this.styleSidebar = JSON.parse(this.getClientsSettingAppBooking?.clients_setting_app_booking?.bookingFlow_sidebar);
    this.bodyStyle = JSON.parse(this.getClientsSettingAppBooking?.clients_setting_app_booking?.bookingFlow_body);

    this.loadComponent();
     const selectedAgency = JSON.parse(localStorage.getItem('selectedAgency'));
    this.currencyAgency = this.currencies.find(c => c.code === selectedAgency.currency);

    if(!this.currencyAgency) {
      this.router.navigateByUrl('home');
      this.notificationService.warning('Moneda no configurada en la agencia');
    }

    if (this.origin == null || this.origin == undefined) {
      this.origin = this.resultSearchService._getOrigin();
    }
    this.itinerary = this._actualItinerary;

    if (this._actualItinerary) {
      if (this._actualItinerary.items.length  == 0){
        this.buttonDisabled = true;
      }
      else
        this.buttonDisabled = false;
    }

    if ( this.itinerary !== null ) {

      this.orderItinerary(this.itinerary);
    }

    this.itineraryService.deleteItem.subscribe((data: any) => {
      this.deleteItem = data;
    })

    this.verifiedProductsTransfers(true);
  }


  ngOnChanges(changes: SimpleChanges): void {
    this.currencyAgency = this.userService.currency;
    if(changes?.['_actualItinerary']?.['currentValue']) {
      if(this.loadingToast) {
        this.notificationService.close(this.loadingToast.toastId);
      }
      this._actualItinerary = changes['_actualItinerary']['currentValue'];
      this.loadComponent();
      this.orderItinerary(this._actualItinerary);
      this.applyImageFilter();
      this.verifiedProductsTransfers(false);
    }
  }

verifiedProductsTransfers(messageAlert: boolean): void {
  if (!this._actualItinerary) return;

  const items = this._actualItinerary.items.filter(
    item => item.category_id === 8 && !!item.noCloneFirstWay
  );

  const entryValue = items.filter(item => item.noCloneFirstWay === 1).length;
  const returnValue = items.filter(item => item.noCloneFirstWay === 2).length;

  if (!entryValue && !returnValue) {
    this.userService.numberNoCloneOneWay = 0;
    return
  };

  const isBalanced = entryValue === returnValue;

  this.buttonDisabled = !isBalanced;

  if (isBalanced) {
    this.userService.numberNoCloneOneWay = 0;
    return};

  const message = entryValue > returnValue
    ? 'Debe seleccionar un traslado de vuelta'
    : 'Debe seleccionar un traslado de ida';

  let oneWayValue = entryValue > returnValue ? 1 : 2;

  if(messageAlert) {
    this.notificationService.info(message);
    this.modifiedTransportPriceSelectedReturn.emit(true);
  }

  this.userService.numberNoCloneOneWay = oneWayValue;

}



  /**
 * Método para inicializar los datos del componente.
 *
 * Este método carga el carrito del usuario a partir del itinerario actual,
 * procesa las destinaciones y configura estados iniciales como precios totales,
 * disponibilidad de botones, y spinner de carga.
 *
 * @origin -> define si es un itinerario de tipo "MULTIDESTINATION"
 * @multidestination -> bandera para viajes multidestino
 * @_actualItinerary: Itinerary -> itinerario actual con los datos del carrito
 * @_destinations: Destination[] -> array que contiene las ciudades y fechas procesadas
 * @firstCharge -> bandera para controlar si es la primera carga
 * @reloadItemsReadyDelete -> bandera para mostrar notificación si no hay items con moneda asignada
 */
  loadComponent() {
    this.userService.origin = this.origin;
    this.multidestination = this.userService.multidestination;
    if (this._actualItinerary) {
      this._emitLoading(true)
      this.userService.fillCart(this._actualItinerary);
      this.totalNetPriceBooking =  parseFloat(this._actualItinerary.totalNetPriceBooking);
      this.totalBlickoins =  this._actualItinerary.totalBlickoins;

      if (this.origin !== undefined && this.origin === "MULTIDESTINATION") {
        this.fillMultidestination(this._actualItinerary);
      } else {
        this.fillItinerary(this._actualItinerary);
      }
      this._emitLoading(false);

      if (this._actualItinerary.items.length == 0) this.buttonDisabled = true;
      else this.buttonDisabled = false;
    }

    if (this._actualItinerary.destination.length > 0) {
      for (let i = 0; i < this._actualItinerary.destination.length; i++) {
        const arrival = this._actualItinerary.destination[i].destination_info.arrival.split('-');
        const departure = this._actualItinerary.destination[i].destination_info.departure.split('-');
        this._destinations.push({
          cityIataCode: this._actualItinerary.destination[i].iata_code,
          cityName: this._actualItinerary.destination[i].destination_info.cityName,
          nights: this._actualItinerary.destination[i].destination_info.nights,
          adults: this._actualItinerary.destination[i].destination_info.adults,
          childs: this._actualItinerary.destination[i].destination_info.childs,
          rooms: this._actualItinerary.destination[i].destination_info.rooms,
          roomsDist: this._actualItinerary.destination[i].destination_info.roomDist,
          yy: this.datePipe.transform(this._actualItinerary.destination[i].destination_info.arrival, 'yy'),
          mm: this.getMonthName(arrival[1]),
          dd: arrival[2],
          yyy: this.datePipe.transform(this._actualItinerary.destination[i].destination_info.departure, 'yy'),
          mmm: this.getMonthName(departure[1]),
          ddd: departure[2]
        });
      }
    }
    this.firstCharge = false;

    if(this.reloadItemsReadyDelete && this._actualItinerary.item && this._actualItinerary.item.length === 0) {
      this.notificationService.success('File sin moneda asignada');
      this.reloadItemsReadyDelete = false;
    }
  }

  /**
 * Método para ordenar los ítems de un itinerario por ciudad.
 *
 * Este método agrupa los productos del itinerario según su ciudad de destino u origen,
 * diferenciando entre categorías de productos (ej: hoteles, traslados).
 *
 * @itinerary: Itinerary -> itinerario que contiene los ítems a ordenar
 * @nuevoObjeto: { [cityName: string]: Item[] } -> objeto agrupado por ciudad
 * @nuevoObjetoAux: { city: string; items: Item[] }[] -> array auxiliar para estructurar los ítems agrupados
 */
  orderItinerary(itinerary): void {
    if (itinerary !== undefined) {
      this.nuevoObjeto = itinerary.items.reduce(function (r, a) {
        if((a.category_id === 1 || a.category_id === 4)){
          r[a.form.destination.city_name] = r[a.form.destination.city_name] || [];
          r[a.form.destination.city_name].push(a);
          return r;
        }
        if(a.category_id === 8) {
          if(a.payload[0]?.transfers?.pickupLocation?.type !== 'airport') {
            r[a.origin.city_name] = r[a.origin.city_name] || [];
            r[a.origin.city_name].push(a);
            return r;
          } else {
            r[a.origin.name] = r[a.origin.name] || [];
            r[a.origin.name].push(a);
            return r;
          }
        }
        //validación para rentacar
        if(a.category_id === 2){
          if(a.payloadUpdate.products[0].others.carRental.pickupLocation.type !== 'airport'){
            r[a.form.origin.city_name] = r[a.form.origin.city_name] || [];
            r[a.form.origin.city_name].push(a);
            return r;
          }else{
            r[a.form.origin.name] = r[a.form.origin.name] || [];
            r[a.form.origin.name].push(a);
            return r;
          }

        }
        //validación para tours
        if(a.category_id === 6){
          r[a.form.destination.city_name] = r[a.form.destination.city_name] || [];
          r[a.form.destination.city_name].push(a);
          return r;
        }

        if(a.category_id === 10) {
          r[a.form.destination.city_name] = r[a.form.destination.city_name] || [];
          r[a.form.destination.city_name].push(a);
          return r;
        }
      }, Object.create(null));


      this.nuevoObjetoAux = Object.keys(this.nuevoObjeto).map((key) => ({
        city: key,
        items: this.groupItemsByDates(this.nuevoObjeto[key]),
      }));

    }
  }

  /**
 * Método para agrupar ítems por ciudad y fechas de llegada y salida.
 *
 * Este método organiza los productos dentro del itinerario agrupándolos primero por ciudad
 * y luego por las mismas fechas de llegada y salida.
 *
 * @items: any[] -> array de ítems a procesar (cada ítem contiene ciudad y fechas)
 * @groupedItems: any[] -> array final agrupado por ciudad y fecha
 *
 * @return groupedItems: arreglo estructurado de ciudades con sus respectivos grupos de fechas.
 */
  groupItemsByDates(items: any[]): any[] {
    const groupedItems: any[] = [];

    items.forEach((item) => {
      const city = item.destination?.destination_info?.cityName;
      const arrivalDate = item.arrivalDate;
      const departureDate = item.departureDate;

      // Buscar la ciudad en el arreglo de groupedItems
      const cityIndex = groupedItems.findIndex((group) => group.city === city);

      if (cityIndex === -1) {
        // La ciudad no ha sido agregada todavía, crear un nuevo grupo para la ciudad
        const cityGroup = {
          city: city,
          items: [
            {
              arrivalDate: arrivalDate,
              departureDate: departureDate,
              items: [item],
            },
          ],
        };
        groupedItems.push(cityGroup);
      } else {
        // La ciudad ya existe en el arreglo de groupedItems, buscar si hay algún grupo con las mismas fechas de entrada y salida
        const dateGroupIndex = groupedItems[cityIndex].items.findIndex(
          (group) =>
            group.arrivalDate === arrivalDate && group.departureDate === departureDate
        );

        if (dateGroupIndex === -1) {
          // No hay grupo con las mismas fechas, crear un nuevo grupo dentro de la ciudad
          const dateGroup = {
            arrivalDate: arrivalDate,
            departureDate: departureDate,
            items: [item],
          };
          groupedItems[cityIndex].items.push(dateGroup);
        } else {
          // Hay un grupo con las mismas fechas, agregar el item al grupo existente
          groupedItems[cityIndex].items[dateGroupIndex].items.push(item);
        }
      }
    });

    // Asegurarse de que cada grupo de fechas tenga un array
    groupedItems.forEach((cityGroup) => {
      cityGroup.items.forEach((dateGroup) => {
        dateGroup.items = Array.isArray(dateGroup.items) ? dateGroup.items : [dateGroup.items];
      });
    });
    return groupedItems;
  }

  /**
 * Método para obtener el itinerario desde el backend.
 *
 * Este método realiza una petición HTTP para recuperar un itinerario específico,
 * guarda la respuesta, ordena los ítems del itinerario, y actualiza el carrito del usuario.
 *
 * @id: string | number -> identificador del itinerario que se desea consultar
 * @itinerary: any -> respuesta del backend que contiene los datos del itinerario
 * @userService.items: any[] -> actualización del carrito de ítems del usuario
 */
  _modifyDates() {
    this._setPayloadArray(this._destinations);
    if (this._activeItinerary !== undefined) {
      this._activeItinerary[0].arrivalDate = this._arrivalDate;
      this._activeItinerary[0].destination = [];
      for (let i = 0; i < this._destinations.length; i++) {
        const date = this._payloadArray[i].arrivalDate.split("-");
        this._destinations[i].yy = this.datePipe.transform(this._arrivalDate, "yy");
        this._destinations[i].mm = this.getMonthName(date[1]);
        this._destinations[i].dd = date[2];

        const destination = {
          iata_code: this._destinations[i]["cityIataCode"],
          destination_info: {
            childs: this._destinations[i]["childs"],
            adults: this._destinations[i]["adults"],
            rooms: this._destinations[i]["rooms"],
            roomDist: this._destinations[i]["roomsDist"],
            position: i + 1,
            nights: this._destinations[i].nights,
            arrival: this._payloadArray[i]["arrivalDate"],
            departure: this._payloadArray[i]["departureDate"],
            cityName: this._destinations[i]["cityName"],
          },
        };

        this._activeItinerary[0].destination.push(destination);
      }
    }
  }

  /**
 * Método para construir el arreglo de payloads de destinos.
 *
 * Este método genera un array de objetos que contienen información de llegada, salida,
 * origen, destino y configuración de habitaciones, basado en los destinos y en el payload existente.
 *
 * @destinations: any -> lista de destinos que incluyen ciudad y noches de estancia
 * @_payloadArray: any[] -> arreglo final de payloads generado para cada destino
 */
  _setPayloadArray(destinations: any) {
    this._payloadArray = [];

    for (let i = 0; i < destinations.length; i++) {
      let arrival = null;
      if (this.payload !== undefined && this.payload !== null) {
        if (this.payload.others !== undefined && this.payload.others !== null) {
          var qtyAdults = 0;
          this.payload.others.hotels.roomConfiguration.forEach((room) => {
            qtyAdults += parseInt(room.adults);
          });
        }
      }
      if (this._arrivalDate !== undefined || this._arrivalDate !== null) {
        arrival = new Date(i === 0 ? this._arrivalDate : this._payloadArray[i - 1].departureDate);
        this._payloadArray[i] = {
          arrivalDate: i === 0 ? this._arrivalDate : this._payloadArray[i - 1].departureDate,
          categoriesId: [1],
          departureDate: this._getDeparture(arrival, destinations[i].nights),
          origin: this.payload === undefined ? "MULTIDESTINATION" : this.payload.origin,
          destination: destinations[i]["cityIataCode"],
          others: this.payload !== undefined ? this.payload.others : null,
          priceFrom: this.payload === undefined ? "MULTIDESTINATION" : this.payload.priceFrom,
          priceTo: this.payload === undefined ? 20000 : this.payload.priceTo,
          providersId: this.payload === undefined ? null : this.payload.providersId,
          qtyPax: qtyAdults,
          qtyProduct: this.payload !== undefined ? this.payload.others.hotels.roomConfiguration.length : null,
        };
      } else {
      }
    }
  }

  /**
 * Método para calcular la fecha de salida en base a la llegada y cantidad de noches.
 *
 * Este método suma las noches a la fecha de llegada y retorna la fecha de salida en formato 'yyyy-MM-dd'.
 *
 * @arrivalDate: Date -> fecha de llegada inicial
 * @nights: number -> cantidad de noches de estancia
 *
 * @return string -> fecha de salida formateada
 */
  _getDeparture(arrivalDate: any, nights: number) {
    arrivalDate.setDate(arrivalDate.getDate() + (nights + 1));
    const month = arrivalDate.getMonth() < 9 ? "0" + (arrivalDate.getMonth() + 1) : arrivalDate.getMonth() + 1;
    const day = arrivalDate.getDate() < 10 ? "0" + arrivalDate.getDate() : arrivalDate.getDate();
    return arrivalDate.getFullYear() + "-" + month + "-" + day;
  }

  /**
 * Método para emitir los destinos activos y controlar el estado del botón.
 *
 * Este método actualiza el estado del botón según la existencia de destinos
 * y emite el itinerario activo mediante el servicio de itinerarios.
 *
 * @update: boolean -> indica si se debe emitir el itinerario actualizado
 */
  _emitDestinations(update: boolean) {
    if (this._destinations.length > 0) {
      this.disableButton = false;
    } else {
      this.disableButton = true;
    }
    this.itineraryService.emitActiveItinerary(this._activeItinerary, update);
  }

  /**
 * Método para determinar el llenado del itinerario.
 *
 * Según el valor del origen, este método decide si llenar el itinerario como
 * multidestino o como itinerario tradicional, y luego detiene el estado de carga.
 *
 * @param itinerary: any -> itinerario a procesar
 */
  funcion(itinerary) {
    if (itinerary !== null && itinerary !== undefined) {
      if (this.origin !== undefined && this.origin === "MULTIDESTINATION") {
        this.fillMultidestination(itinerary);
      } else {
        this.fillItinerary(itinerary);
      }
      this._emitLoading(false);
    }
  }

  /**
 * Método para emitir el estado de carga.
 *
 * Este método emite un booleano indicando si el sistema está en proceso de carga o no.
 *
 * @param isLoading: boolean -> true si está cargando, false si terminó
 */

  _emitLoading(isLoading: boolean) {
    this.isLoading.emit(isLoading);
  }

  /**
 * Método para emitir un itinerario actualizado.
 *
 * Este método emite el itinerario actual a través del EventEmitter correspondiente.
 *
 * @param itinerary: any -> itinerario a emitir
 */

  _emitItinerary(itinerary: any) {
    this._itinerary.emit(itinerary);
  }

/**
 * Método para cargar un itinerario de tipo multidestino.
 *
 * Este método procesa la estructura del itinerario recibido, identificando los destinos,
 * sus fechas de llegada y salida, los productos asociados a cada destino, y organiza
 * los ítems de productos para construir el objeto `multidestination`.
 *
 * Si el destino ya existe en el array, se agregan los nuevos ítems. Si no, se crea una nueva entrada.
 * También realiza la búsqueda de productos actualizados si existe un `payloadUpdate`.
 *
 * @param itinerary: any -> Itinerario completo que contiene destinos e ítems a procesar.
 *
 * Lógica principal:
 * - Se resetea `this.multidestination`.
 * - Se emite el itinerario actualizado.
 * - Se recorren los destinos del itinerario.
 * - Para cada destino:
 *    - Se extraen las fechas de llegada y salida.
 *    - Se recorren los ítems para asociarlos al destino correspondiente.
 *    - Se asignan productos si están disponibles o se buscan vía API (`_rest.doPost`).
 *    - Se agrupan los ítems bajo el destino respectivo en `this.multidestination`.
 *
 * Notas:
 * - Si no hay ítems en el itinerario, `multidestination` se deja en `undefined`.
 * - Hay un pequeño error de tipado en el código original: `lenght` debería ser `length`.
 */
  fillMultidestination(itinerary: any) {
    this.multidestination = undefined;
    this._emitItinerary(itinerary);
    let departureDate;
    let arrivalDate;

    if (itinerary[0] !== undefined) {
      for (let i = 0; i < itinerary[0].destination.length; i++) {
        let items: any[] = [];
        const destiny = itinerary[0].destination[i];

        if (destiny.destination_info.arrival !== null && destiny.destination_info.departure !== null) {
          arrivalDate = destiny.destination_info.arrival.split("-");
          departureDate = destiny.destination_info.departure.split("-");
        } else {
          const dateRange: RangeDateItinerary = this.itineraryService.evaluateDateItineraryRange(itinerary[0].items);
          arrivalDate = dateRange.arrivalDate.toString().split("-");
          departureDate = dateRange.departureDate.toString().split("-");
        }

        //cantidad de items
        for (let j = 0; j < itinerary[0].items.length; j++) {
          const item = itinerary[0].items[j];

          //payload se le asigna el producto si existe
          let payload = item.payloadUpdate && item.payloadUpdate.products ? item.payloadUpdate.products[0] : item.payload;
          if (payload && payload.destination === destiny.iata_code) {
            //console.log('entro a payload && payload.destination === destiny.iata_code');
            //se añade item a items array
            items[j] = {
              adult: payload.qtyPax,
              children: payload.others.child,
              item: item,
              product: null,
              categoryName: item.categoryName,
            };
            //si tiene payload el item hace una busqueda de product
            if (item.payloadUpdate) {
              this._rest.doPost("app", "search/products", item.payloadUpdate).subscribe(
                (response: any) => {
                  if (response && response.status && response.results) {
                    if (response.results[0] !== undefined) {
                      items[j].product = response.results[0];
                    } else {
                      items[j].product = response.results;
                    }
                  }
                },
                (error) => {
                  console.log(error.message);
                }
              );
            }


            if (this.multidestination === undefined) {
              this.multidestination = [];
            }

            let multiExist;

            if (this.multidestination.length > 0) {
              //busca si existe ya un destino que le pertenece a ese producto
              multiExist = this.multidestination.find((element: any) => element.city == destiny.destination_info.cityName);
              //console.log('encontro que ya existe un destino en multi con ese nombre?', multiExist);
            }

            if (multiExist) {
              let index = this.multidestination.indexOf(multiExist);
              this.multidestination[index].items.push(items[j]);
            } else {
              const anioArrival = arrivalDate[0].substring(2);
              const anioDeparture = departureDate[0].substring(2);

              this.multidestination[i] = {
                dd: arrivalDate[2].length > 2 ? arrivalDate[2].substring(0, 2) : arrivalDate[2],
                ddd: departureDate[2].length > 2 ? departureDate[2].substring(0, 2) : departureDate[2],
                mm: this.getMonthName(arrivalDate[1]),
                yy: anioArrival,
                city: destiny.destination_info.cityName,
                items: items.filter(Boolean),
              };
            }
          }
        }

        if (itinerary[0].items.length < 1) {
          this.multidestination = undefined;
        }
      }
    }
  }

  /**
 * Método para cargar un itinerario normal (no multidestino).
 *
 * Procesa los ítems del itinerario recibido y construye el array `this.itinerary`,
 * organizando la información de fechas, ciudad de destino, cantidad de pasajeros
 * y categoría del producto.
 *
 * Particularidades:
 * - Si el item pertenece a la categoría "DISNEY", se maneja de manera especial utilizando `getDisneyItem`.
 * - Si existe información actualizada (`payloadUpdate`), se prioriza sobre la original.
 *
 * @param itinerary: any -> Estructura que contiene la lista de ítems del itinerario.
 *
 * Lógica principal:
 * - Se recorren los ítems dentro del primer elemento del itinerario.
 * - Para cada ítem:
 *    - Se obtienen las fechas de llegada y salida.
 *    - Se formatean las fechas para presentar día, mes y año.
 *    - Se crea un objeto que representa la estadía del ítem en el destino.
 *    - Si el ítem es de categoría "DISNEY", se maneja a través de `getDisneyItem`.
 * - Se asigna el ID del itinerario.
 * - Se guarda también la lista de ítems completa (`itineraryItems`).
 *
 * Notas:
 * - Si no hay ítems o `this.itinerary` está indefinido, se inicializa como array vacío.
 * - Utiliza `moment.js` y `datePipe` para el manejo de fechas.
 */
  fillItinerary(itinerary: any) {
    let departureDate;
    let arrivalDate;
    if (itinerary.length > 0 && this.itinerary != undefined) {
      //  this.itinerary = [];

      for (let i = 0; i < itinerary[0].items.length; i++) {
        let arrival;
        arrivalDate =
          itinerary[0].items[i].categoryName == "DISNEY"
            ? itinerary[0].items[i].hotel.dateIni.split("-")
            : itinerary[0].items[i].arrivalDate.split("-");
        departureDate =
          itinerary[0].items[i].categoryName == "DISNEY"
            ? itinerary[0].items[i].hotel.dateEnd.split("-")
            : itinerary[0].items[i]?.departureDate?.split("-");
        arrival = moment(itinerary[0].items[i].arrivalDate);

        const item = itinerary[0].items[i];

        const anioArrival = arrivalDate !== null ? arrivalDate[0].substring(2) : null;

        const anioDeparture = departureDate !== null ? departureDate[0]?.substring(2) : null;

        this.itinerary[i] =
          item["categoryName"] === "DISNEY"
            ? this.getDisneyItem(item)
            : {
                orderDateDestiny:
                  this.datePipe.transform(arrival, "yy") +
                  "-" +
                  this.datePipe.transform(arrival, "MM") +
                  "-" +
                  this.datePipe.transform(arrival, "dd"),
                dd: arrivalDate[2].length > 2 ? arrivalDate[2].substring(0, 2) : arrivalDate[2],
                mm: this.getMonthName(arrivalDate[1]),
                yy: anioArrival,
                city: item.payloadUpdate ? item.payloadUpdate.products[0].destination : item.payload.destination,
                adult: item.payloadUpdate ? item.payloadUpdate.products[0].qtyPax : null,
                children: item.payloadUpdate ? item.payloadUpdate.products[0].others.child : null,
                item: item,
                ddd: departureDate[2].length > 2 ? departureDate[2].substring(0, 2) : departureDate[2],
                mmm: this.getMonthName(departureDate[1]),
                yyy: anioDeparture,
                product: null,
                categoryName: item.categoryName,
              };
      }
      this.id = itinerary.id;

      this.itineraryItems = itinerary[0].items;
    } else {
      this.itinerary = [];
    }
  }

  /**
 * Método auxiliar para procesar ítems de categoría "DISNEY".
 *
 * Crea un objeto especial para los productos Disney, tomando en cuenta las fechas
 * de llegada y salida, la cantidad de noches, y el destino predefinido ("ORL").
 *
 * @param _item: any -> Ítem del itinerario con categoría "DISNEY".
 *
 * @returns object -> Objeto formateado con información específica para un ítem Disney.
 *
 * Lógica principal:
 * - Calcula la cantidad de noches entre la fecha de llegada y salida.
 * - Formatea las fechas de llegada y salida para facilitar su presentación.
 * - Agrega identificadores y datos relevantes del hotel asociado.
 */
  getDisneyItem(_item: any): object {
    const arrival: any = moment(_item["form"]["arrivalDate"]);
    const departure: any = moment(_item["form"]["departureDate"]);
    const nights: any = departure.diff(arrival, "days");
    const item = {
      orderDateDestiny:
        this.datePipe.transform(arrival, "yy") +
        "-" +
        this.datePipe.transform(arrival, "MM") +
        "-" +
        this.datePipe.transform(arrival, "dd"),
      itemInfo: _item,
      city: "ORL",
      id: _item["id"],
      idProduct: _item["hotel"]["id"],
      dd: this.datePipe.transform(arrival, "dd"),
      mm: this.datePipe.transform(arrival, "MMM"),
      yy: this.datePipe.transform(arrival, "yy"),
      ddd: this.datePipe.transform(departure, "dd"),
      mmm: this.datePipe.transform(departure, "MMM"),
      yyy: this.datePipe.transform(departure, "yy"),
      destination: _item["hotel"]["destination"],
      nights: nights,
      categoryName: "DISNEY",
    };
    // console.log('Le item', item);
    return item;
  }

  /**
 * Muestra un modal de confirmación para eliminar un ítem del itinerario.
 *
 * Si el usuario confirma, se emiten eventos para:
 * - Señalar que se debe recargar la lista (`reloadItemsReadyDelete`).
 * - Emitir el evento de producto eliminado (`productDeleteEmitter`).
 * - Emitir la moneda eliminada (`currencyRemoveEmit`).
 * - Ejecutar el método `remove` del `itineraryService` para eliminar el ítem.
 *
 * @param item: any (opcional) -> Ítem que se desea eliminar (puede ser un producto o su referencia).
 * @param index: number (opcional) -> Índice del ítem en la lista.
 * @param i: number (opcional) -> No utilizado en esta función actualmente.
 *
 * Consideraciones:
 * - Si el usuario cancela, no se elimina el ítem y se setea `deleteItem` a `true`.
 * - Utiliza el componente `ConfirmationModalComponent` para mostrar el modal.
 */
  removeItem(item?: any, index?: number, i?: number) {

    if(item.category_id === 8 && item?.firstWay) {
      this.verifiedProductsTransfers(false);

      const initialState: ModalOptions = {
        initialState: {
          message: 'Esta acción eliminará los traslados de ida y vuelta <br /> ¿Está seguro de eliminar los productos?'
        }
      };
        // Combina el estado inicial con la configuración del modal
      const modalConfig:any = {
        ...initialState,
        ...this.config,
      };

      this.bsModalRef = this.modalService.show(ConfirmationModalComponent, modalConfig);
      this.deleteItem = false;

      const confirmSubscription = this.bsModalRef.content.confirmResult.subscribe((result: boolean) => {
        if(result) {

          if (index !== -1) {

            const pairedItems = this.findPairedItems(item, this._actualItinerary['items']);

            if(pairedItems.length === 2) {


                this.processItem(pairedItems[0], item.currency);

                // Procesar el segundo item con delay si existe
                if (pairedItems.length >= 2) {
                  setTimeout(() => {
                    this.processItem(pairedItems[1], item.currency);
                  }, 500); // 500ms de delay
                }


            } else {
              this.deleteItem = true;
              return;
            }

          }

        } else {
          this.deleteItem = true;
          return;
        }
      })


    } else {

      if(item.category_id === 8 && item?.wayNoCloneVehicleDoubleWay) {
        this.verifiedProductsTransfers(false);
      }

      const initialState: ModalOptions = {
        initialState: {
          message: '¿Está seguro de eliminar el producto?'
        }
      };
        // Combina el estado inicial con la configuración del modal
      const modalConfig:any = {
        ...initialState,
        ...this.config,
      };

      // Pasa modalConfig al servicio para mostrar el modal
      this.bsModalRef = this.modalService.show(ConfirmationModalComponent, modalConfig);
      this.deleteItem = false;
      const confirmSubscription = this.bsModalRef.content.confirmResult.subscribe((result: boolean) => {
        if(result) {
          if (index !== -1) {

            if(item.categoryId === 6) {

            }




          this.loadingToast = this.notificationService.loading('Procesando eliminación...');

            const paxesQty = {
              destination: item.destination?.iata_code,
              adults: Number(item.paxAdults),
              children: Number(item.paxChildren)
            }
            this._actualItinerary['destination'].forEach((destination: any) => {
                if(destination.iata_code === paxesQty.destination) {
                  destination.destination_info.adults -= paxesQty.adults;
                  destination.destination_info.childs -= paxesQty.children;
                }
            });
            this.reloadItemsReadyDelete = true;
            this.productDeleteEmitter.emit();
            this.itineraryService.currencyRemoveEmit.next(item.currency);
                if((item.category_id === 1 || item.category_id === 4) && (this.payload[0].categoriesId[0] === 1 || this.payload[0].categoriesId[0] === 4)) {
                  this.hotelService.removeSelectedRoom(item);
                }
                if(item.category_id === 8 && this.payload[0].categoriesId[0] === 8) {
                  this.transporsService.removeVehicle(item);
                }


            this.itineraryService.remove(item.item !== undefined ? item.item : item, null);

            // this.router.navigate(["results"]);
          }
        } else {
          this.deleteItem = true;
        }
      });
    }

  }

  private processItem(itemVehicle: any, currency: string): void {

  // Actualizar información de pax en destinos
  const paxesQty = {
    destination: itemVehicle.destination?.iata_code,
    adults: Number(itemVehicle.paxAdults),
    children: Number(itemVehicle.paxChildren)
  };

  this._actualItinerary['destination'].forEach((destination: any) => {
    if(destination.iata_code === paxesQty.destination) {
      destination.destination_info.adults -= paxesQty.adults;
      destination.destination_info.childs -= paxesQty.children;
    }
  });

  // Emitir eventos
  this.reloadItemsReadyDelete = true;
  this.productDeleteEmitter.emit();
  this.itineraryService.currencyRemoveEmit.next(currency);

  // Remover vehículo
  this.transporsService.removeVehicle(itemVehicle);

  // Eliminar el item del itinerario
  this.itineraryService.remove(itemVehicle);
}

  private findPairedItems(mainItem: any, allItems: any[]): any[] {
  const pairedItems: any[] = [mainItem];

  // Si el item principal tiene firstWay = 1, buscar el que tenga firstWay = 2 con mismo vehicleCode
  if (mainItem.firstWay === 1) {
    const matchingItem = allItems.find(otherItem =>
      otherItem !== mainItem &&
      otherItem.firstWay === 2 &&
      otherItem.vehicleCode === mainItem.vehicleCode
    );

    if (matchingItem) {
      pairedItems.push(matchingItem);
    }
  }
  // Si el item principal tiene firstWay = 2, buscar el que tenga firstWay = 1 con mismo vehicleCode
  else if (mainItem.firstWay === 2) {
    const matchingItem = allItems.find(otherItem =>
      otherItem !== mainItem &&
      otherItem.firstWay === 1 &&
      otherItem.vehicleCode === mainItem.vehicleCode
    );

    if (matchingItem) {
      pairedItems.unshift(matchingItem); // Agregar al inicio para mantener orden 1, 2
    }
  }

  return pairedItems;
}

  /**
 * Obtiene el nombre abreviado del mes en inglés a partir del número de mes.
 *
 * @param month: number -> Número del mes (1 para Enero, 2 para Febrero, etc.).
 * @returns string -> Nombre del mes en formato corto ("Jan", "Feb", etc.).
 *
 * Consideraciones:
 * - El array `monthNames` tiene un pequeño error tipográfico: "Octr" debería ser "Oct".
 * - Si el parámetro `month` es `null`, no devuelve nada.
 */
  getMonthName(month: number) {
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Octr", "Nov", "Dec"];
    if (month !== null) {
      return monthNames[month - 1];
    }
  }

  /**
 * Emite un evento para indicar un cambio de pestaña.
 *
 * El evento emitido es un booleano `true` para señalar que el cambio debe ocurrir.
 *
 * @returns void
 */
  changeTab() {
    this.changeTabEmitter.emit(true);
  }

  /**
 * Valida si una cadena (`str`) es de tipo string y no es nula ni indefinida.
 *
 * @param str: any -> Cadena que se desea validar.
 * @returns string | undefined -> Retorna la misma cadena si es válida.
 *
 * Nota:
 * - Hay un pequeño error: si `str` no es válida, deberías retornar un string de error o manejarlo mejor.
 * - El nombre del método tiene un error tipográfico: debería ser `stringUpperCase`.
 */
  stringUpperCase(str: any): string {
    return (typeof str === 'string' && str) ? str : 'Revisar título desde Octopus';
  }

  /**
 * Verifica si un índice corresponde al último elemento de un array.
 *
 * @param index: number -> Índice actual.
 * @param array: any[] -> Array sobre el cual se realiza la verificación.
 * @returns boolean -> `true` si es el último índice, de lo contrario `false`.
 */
  public isLastIndex(index: number, array: any[]): boolean {
    return index === array.length - 1;
  }







       applyImageFilter() {
        const color = this.styleSidebar?.color_2;
        const tempFilterObj = CssFilterConverter.hexToFilter(color, { sheen: false });

        //Extraemos el literal en String de la conversión
        const tempFilterStr = Object.keys(tempFilterObj).map(key => `${key}(${tempFilterObj[key]})`).join(" ");

        // Convierte el color a un objeto de filtro de CSS y extrae los filtros de la respuesta color del resultado.
        const colorRegex = /color\((.*)\)/;
        const colorMatch = tempFilterStr.match(colorRegex);
        const colorFilter = colorMatch ? colorMatch[1] : "";

        this.filterColorIcon = colorFilter;
        // Establece el atributo de estilo "filter" en el elemento de imagen con los filtros de color extraídos.
        setTimeout(() => {
          this.icons.forEach(icon => {
            icon.nativeElement.setAttribute('style', `filter: ${this.filterColorIcon}; width: 16px;`);
          });

          this.icons_two.forEach(icon => {
          icon.nativeElement.setAttribute('style', `filter: ${this.filterColorIcon}; width: 14px;`);
        });
         // console.log(this.filter);
        }, 100);
      }

      getCancellationPolicies(type: string, item: any): boolean {

        switch(type) {
          case 'hotels':
              return item.room?.cancellationPolicy && item.room?.cancellationPolicy.length > 0;
          case 'tours':

            if(item.subCategoryId === 6) {
              return item.cancellationPolicies.cancellationPolicies && item.cancellationPolicies.cancellationPolicies.length > 0;
            }

        }

          return item?.cancellationPolicies && item?.cancellationPolicies.length > 0;
      }

        removeOptional(optional, index):void{
          const arrayOptional = this.nuevoObjetoAux[0].items[0].items[0].items[0].serviceExtra;
          const initialState: ModalOptions = {
              initialState: {
                message: 'Esta seguro de eliminar el opcional?'
              }
            };
              // Combina el estado inicial con la configuración del modal
            const modalConfig:any = {
              ...initialState,
              ...this.config,
            };

          this.bsModalRef = this.modalService.show(ConfirmationModalComponent, modalConfig);
          const confirmSubscription = this.bsModalRef.content.confirmResult.subscribe((result: boolean) => {
              if(result) {
                if (index !== -1) {
                  this.itineraryService.removeOptional(optional, index)
                }
              }
            });

        }

getTotalPrice(item: any, category: string): any {

  switch(category) {
    case 'hotels':
      // Impuestos no incluidos (a pagar en destino) — solo para mostrar, no forma parte de
      // ningún total real del item. Vive en item.room.pricing, no en item directo.
      const hotelTaxesExcluded = item.room?.pricing?.taxesExcluded || 0;
      if(item.isPaidAgency || item.isPaidProvider) {
        if(item.converted_amounts) {
          return Number(item?.converted_amounts?.netPriceAgent) + hotelTaxesExcluded;
        } else {
          return item.optionNightsNetTotalProf + hotelTaxesExcluded;
        }
      } else {
          let price = this.currencyPipe.transform(
                                              item.optionNightsNetTotalProf + hotelTaxesExcluded,
                                              item?.currency,
                                              this.currencyAgency?.code,
                                              this.currencies);

            if(price) {
              return price.toFixed(2);
            }
      }
    case 'transports':
      if(item.isPaidAgency || item.isPaidProvider) {
        if(item.converted_amounts) {
          return item?.converted_amounts?.netPriceAgent;
        } else {
          return item.netPriceBookingWithIncluded && item.netPriceBookingWithIncluded > item.totalPriceProf
                                       ? item.netPriceBookingWithIncluded : item.totalPriceProf;
        }
      } else {

        let price = item.netPriceBookingWithIncluded && item.netPriceBookingWithIncluded > item.totalPriceProf
                                       ? item.netPriceBookingWithIncluded : item.totalPriceProf;

        price = this.currencyPipe.transform(
                                              price,
                                              item?.currency,
                                              this.currencyAgency?.code,
                                              this.currencies
                                            );

        if(price) {
          return price.toFixed(2);
        }
      }
    case 'tours':
      if(item.isPaidAgency || item.isPaidProvider) {
        if(item.converted_amounts) {
          return item?.converted_amounts?.netPriceAgent;
        } else {
          return item.netPriceBookingWithIncluded && item.netPriceBookingWithIncluded > item.totalPriceProf
                                       ? item.netPriceBookingWithIncluded : item.totalPriceProf;
        }
      } else {

        let price = item.netPriceBookingWithIncluded && item.netPriceBookingWithIncluded > item.totalPriceProf
                                       ? item.netPriceBookingWithIncluded : item.totalPriceProf;

        price = this.currencyPipe.transform(
                                              price,
                                              item?.currency,
                                              this.currencyAgency?.code,
                                              this.currencies
                                            );

        if(price) {
          return price.toFixed(2);
        }
      }
    case 'insurance':
       if(item.isPaidAgency || item.isPaidProvider) {
        if(item.converted_amounts) {
          return item?.converted_amounts?.netPriceAgent;
        } else {
          return item.netPriceAgent;
        }
      } else {

       const price = this.currencyPipe.transform(
                                              item.netPriceAgent,
                                              item?.currency,
                                              this.currencyAgency?.code,
                                              this.currencies
                                            );

        if(price) {
          return price.toFixed(2);
        }
      }
    case 'RENT-A-CAR':
      if (item.isPaidAgency || item.isPaidProvider) {
        if (item.converted_amounts) {
          return item?.converted_amounts.netPriceAgent;
        } else {
          return item.netPriceProf;
        }
      } else {
        const price = this.currencyPipe.transform(
          item.netPriceAgent,
          item?.currency,
          this.currencyAgency?.code,
          this.currencies
        );

        if (price) {
          return price.toFixed(2);
        }
      }

  }
}

getCityGroup(data) {
  if(typeof data === 'string' && data === 'undefined') {
    return false;
  } else {
    return true;
  }
}

  openModalForTransport(): void {
    this.openModalFly.emit();
  }



  formatDate(date: string): string {
  if (!date) return '';
  return moment(date).format('ddd DD MMM YYYY');
}

toggleExpand(itemId: number): void {
  if (this.expandedItems.has(itemId)) {
    this.expandedItems.delete(itemId);
  } else {
    this.expandedItems.add(itemId);
  }
}

// Método para verificar si un item está expandido
isExpanded(itemId: number): boolean {
  return this.expandedItems.has(itemId);
}

toggleExpandBlickoins(itemId: number): void {
  if (this.expandedItemsBlickoins.has(itemId)) {
    this.expandedItemsBlickoins.delete(itemId);
  } else {
    this.expandedItemsBlickoins.add(itemId);
  }
}

// Método para verificar si un item está expandido
isExpandedBlickoins(itemId: number): boolean {
  return this.expandedItemsBlickoins.has(itemId);
}

      getTypeWay(typeWay: any): string {
        if(typeWay !== undefined) {
          return typeWay === 1 ? 'IDA' : 'VUELTA';
        } else {
          return '  ';
        }
      }



}
